import {
  AUTH_LOGIN,
  AUTH_LOGOUT, CHANGE_USER_WORK_STATUS,
  CREATE_USER, DISABLE_2FA,
  EDIT_BALANCE, EDIT_SUPPORT_LIMIT,
  EDIT_USER, ENABLE_2FA, GET_2FA_DATA,
  LOAD_USERS_LIST, RESET_SUPPORT_LIMIT,
} from './user';
import { LOAD_DEPOSITS_LIST } from "@/store/const/deposits";
import {
  ADD_WITHDRAW,
  BUMP_WITHDRAW, CANCEL_WITHDRAW,
  CONFIRM_WITHDRAW,
  LOAD_WITHDRAWS_LIST,
  RESTART_WITHDRAW
} from "@/store/const/withdraws";
import { CREATE_WALLET, LOAD_AML_REPORTS, LOAD_WALLETS_LIST, SET_WALLET_DESCRIPTION, SET_WALLET_FROZEN } from "@/store/const/wallets";
import { LOAD_AML_BALANCE, LOAD_BALANCES } from "@/store/const/node";
import { ADD_WHITELIST_WALLET, DELETE_WHITELIST_WALLET, LOAD_SETTINGS, UPDATE_ACCUMULATION_SETTINGS, UPDATE_SETTING } from "@/store/const/settings";


const path = {
  [AUTH_LOGIN]: 'api/users/login',
  [AUTH_LOGOUT]: 'api/users/logout',
  [LOAD_USERS_LIST]: 'api/users',
  [CREATE_USER]: 'api/users/register',
  [EDIT_USER]: 'api/users/:name:',
  [EDIT_BALANCE]: 'api/users/:id:/balance',
  [EDIT_SUPPORT_LIMIT]: 'api/users/:id:/limit/edit',
  [RESET_SUPPORT_LIMIT]: 'api/users/:id:/limit/reset',
  [CHANGE_USER_WORK_STATUS]: 'api/users/settings/work_status/:status:',
  [GET_2FA_DATA]: 'api/users/2fa/data',
  [ENABLE_2FA]: 'api/users/2fa/enable',
  [DISABLE_2FA]: 'api/users/2fa/disable',
  [LOAD_DEPOSITS_LIST]: 'api/deposits',
  [LOAD_WITHDRAWS_LIST]: 'api/withdraws',
  [ADD_WITHDRAW]: 'api/withdraws',
  [CONFIRM_WITHDRAW]: 'api/withdraws/confirm/:id:',
  [RESTART_WITHDRAW]: 'api/withdraws/restart/:id:',
  [BUMP_WITHDRAW]: 'api/withdraws/bump/:id:',
  [CANCEL_WITHDRAW]: 'api/withdraws/cancel/:id:',
  [LOAD_WALLETS_LIST]: 'api/wallets',
  [LOAD_AML_REPORTS]: 'api/wallets/:address:/aml-reports',
  [CREATE_WALLET]: 'api/wallets',
  [SET_WALLET_FROZEN]: 'api/wallets/:address:/frozen',
  [SET_WALLET_DESCRIPTION]: 'api/wallets/:address:/description',
  [LOAD_BALANCES]: 'api/node/balances',
  [LOAD_AML_BALANCE]: 'api/node/aml-balance',
  [LOAD_SETTINGS]: 'api/settings',
  [UPDATE_SETTING]: 'api/settings/:name:',
  [UPDATE_ACCUMULATION_SETTINGS]: 'api/settings/accumulation/config',
  [ADD_WHITELIST_WALLET]: 'api/settings/withdraws/whitelist',
  [DELETE_WHITELIST_WALLET]: 'api/settings/withdraws/whitelist',
};
export default path;
